import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'aqua-app-download',
  templateUrl: './app-download.component.html',
  styleUrls: ['./app-download.component.css']
})
export class AppDownloadComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/pages/app-download/app-download.component.ts